/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../hooks/useSendTelemetry';
import { Box } from '@getgo/chameleon-chakra-ui';
import { GoToText } from '../../Text/GoToText';
import { GoToLink } from '../../Text/GoToLink';
import { Spacing } from '../../../themes/GoToTheme';
import { GoToErrorHeading } from '../../JoinPages/GoToPages/Components/Heading/GoToErrorHeading';

const messages = defineMessages({
  heading: {
    id: 'goto.error.heading',
  },
  troubleshootingInstructions: {
    id: 'goto.error.troubleshooting.generic',
  },
  supportText: {
    id: 'goto.error.support',
  },
});

export const GoToError: React.FC = () => {
  const { formatMessage: f } = useIntl();
  const sendTelemetry = useSendTelemetry();
  const supportUrl = 'https://support.goto.com/training';

  useEffect(() => {
    sendTelemetry(
      TelemetryComponent.Web,
      TelemetryAction.Fail,
      TelemetryState.Error
    );
  });

  return (
    <>
      <GoToErrorHeading>{f(messages.heading)}</GoToErrorHeading>
      <Box maxWidth='420px'>
        <GoToText>{f(messages.troubleshootingInstructions)}</GoToText>
      </Box>
      <GoToLink href={supportUrl} isExternal mt={Spacing.CoreLayout4}>
        {f(messages.supportText)}
      </GoToLink>
    </>
  );
};
